import { Client } from "../../clients/client";
import { PaginationForm, Pagination } from "@/common/mixins/pagination";
import { UserCreateForm } from "./forms/UserCreateForm";
import { UserSetPasswordForm } from "./forms/UserSetPasswordForm";
import { UserUpdateForm } from "./forms/UserUpdateForm";
import { User } from "./models/User";

export class UserUseCase {
  constructor(private client: Client) {}

  public async createUser(form: UserCreateForm): Promise<User> {
    return this.client.users.postUsers({
      email: form.email,
      password: form.passwordForm.password,
      role: form.role!
    });
  }
  public async getUsers(form: PaginationForm): Promise<Pagination<User>> {
    return this.client.users.getUsers({
      page: form && form.page,
      limit: form && form.perPage
    });
  }

  public async getUser(id: number): Promise<User> {
    return this.client.users.getUser(id);
  }

  public async updateUser(form: UserUpdateForm): Promise<User> {
    return this.client.users.patchUsers({
      id: form.user!.id,
      role: form.newRole
    });
  }

  public async setPasswordUser(form: UserSetPasswordForm): Promise<User> {
    return this.client.users.patchSetPassword({
      id: form.user!.id,
      password: form.passwordForm.password
    });
  }

  public async deleteUser(id: number): Promise<User> {
    return this.client.users.deleteUsers({ id });
  }
}
